module.exports = __webpack_public_path__ + "static/mpost78.ae09fb85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slideshow/mpost78.jpg
// module id = 257
// module chunks = 23899280101116 35783957827783